import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import Home from "../pages/home/page";

const HakkimizdaPage   = lazy(() => import("../pages/hakkimizda/page"));
const HizmetlerPage    = lazy(() => import("../pages/hizmetler/page"));
const ServiceDetailPage = lazy(() => import("../pages/hizmetler/detail/page"));
const ReferanslarPage  = lazy(() => import("../pages/referanslar/page"));
const SssPage          = lazy(() => import("../pages/sss/page"));
const IletisimPage     = lazy(() => import("../pages/iletisim/page"));
const KvkkPage         = lazy(() => import("../pages/kvkk/page"));
const CerezPage        = lazy(() => import("../pages/cerez-politikasi/page"));
const NotFound         = lazy(() => import("../pages/NotFound"));

const routes: RouteObject[] = [
  { path: "/",                element: <Home /> },
  { path: "/hakkimizda",     element: <HakkimizdaPage /> },
  { path: "/hizmetler",      element: <HizmetlerPage /> },
  { path: "/hizmetler/:slug", element: <ServiceDetailPage /> },
  { path: "/referanslar",    element: <ReferanslarPage /> },
  { path: "/sss",            element: <SssPage /> },
  { path: "/iletisim",           element: <IletisimPage /> },
  { path: "/kvkk",               element: <KvkkPage /> },
  { path: "/cerez-politikasi",   element: <CerezPage /> },
  { path: "*",                   element: <NotFound /> },
];

export default routes;
